<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5cAcDr/images/cover.jpg?1685327422986" alt="This image is the cover for the book Curious Sustenance"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Curious Sustenance
      </h1>
      <p class="bookDescription body article font2">
        <p>Ross Jenson is looking forward to a little midmorning delight to celebrate making Lifetime in Weight Watchers, but after he spent eight months losing ninety-eight pounds, what his lover gets him is a triple-layer chocolate cake. When Ross refuses to eat it, the newly minted ex leaves the country and dumps him via e-mail, with three sentences and a link to a chubby chasers web site. A few days later, Ross’s best friend and workout buddy takes him to her favorite club for drinks. Ross is shocked when he realizes it’s a sex club but warms to the idea in record time when a mysterious Japanese man and his silken ropes sweep him off his feet. Ross has never thought of himself as adventurous, but he can’t stop thinking about the man who makes his bones feel like gummy worms.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charley Descoteaux
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d149c83